import { Box } from "@mui/material";

const IframeEmbed = ({ url = "" }) => {
  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        height: "100%",
        border: "1px solid #ccc",
        borderRadius: 2,
        overflow: "hidden",
      }}
    >
      <iframe
        src={url}
        title="Contact Expert"
        width="100%"
        height="100%"
        style={{ border: "none" }}
        allowFullScreen
      />
    </Box>
  );
};

export default IframeEmbed;
